import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#111] flex items-center justify-center px-6">
      <div className="text-center">

        {/* ISUZU Red Logo Style */}
        <h1 className="text-6xl font-extrabold tracking-wider text-[#e60012] mb-2">
          404
        </h1>

        {/* Subtext */}
        <p className="text-gray-300 text-lg mb-6">
          The page you are looking for is not available.
        </p>

        {/* Truck Outline (Professional, Minimal) */}
        <div className="mb-8 opacity-40">
          <img
            src="https://cdn-icons-png.flaticon.com/512/7432/7432761.png"
            alt="Truck"
            className="w-40 mx-auto"
          />
        </div>

        {/* Button */}
        <Link
          to="/"
          className="
            inline-block px-8 py-3 rounded-md
            bg-[#e60012] text-white font-semibold
            hover:bg-red-700 transition-all duration-300
          "
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
}
